<template>
  <div>
     <card>
      <div slot="header">
        <span>Propriedades Clientes</span>
      </div>
      <div class="mt-4 mb-4">
        <region-map
          :markers.sync="properties"
          :height="500"
          :zoom="6"
          readOnly
        />
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn } from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import RegionMap from '@/views/Sectors/regionMap';

export default {
  name: "app",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    Multiselect,
    RegionMap,
  },
  data() {
    return {
      anosafra: [],
      modals: {
        modal0: false
      },
      filterSelects: {},
      filter: {},
      errors: [],
      regions: [],
      properties: [],
      // flag de verificação se foi pesquisado algo
      filtered: false,
      farms: [],
      paginated_data: [],
    };
  },
  // created() {
  //   this.setProperties();
  // },
  mounted() {
    // this.setProperties();
    this.getAnosafras();
    this.getClients();
  },
  methods: {
    rowClicked(row) {
      this.$refs.regions.toggleRowExpansion(row);
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    getClients(){
      if(this.$currentUser().is_salesman) {
        const data = { unpaged: true, q: { user_ids: this.$currentUser().id, anosafra_id: this.anosafra.id } }

        this.$http.secured.get("/api/v1/clients", { params: data })
          .then(response => {
            this.clients = response.data.clients.map(client => client.farms)
            this.clients.map(item => {
              item.map(farm => {
                this.properties.push({ coordinates: farm.coordinates, tooltip: `${farm.tooltip} \n ${farm.client_name}` })
              })
            })
          })
          .catch(error => this.setError(error, "Something went wrong"));
      }
    },
    getAnosafras() {
      this.$http.secured
        .get("/api/v1/anosafras")
        .then(response => {
          this.anosafra = response.data.anosafras[0];
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    // setProperties() {
    //   this.$http.secured
    //     .get("/api/v1/farms")
    //     .then(response => {
    //       this.properties = response.data;
    //       this.properties = this.properties.map(item => {
    //         return {
    //           ...item,
    //           coordinates: item.coordinates ? item.coordinates : ['0-0', '0-0']
    //         }
    //       })
    //       console.log('Propriedades', this.properties)
    //     })
    //     .catch(error => this.setError(error, "Something went wrong"));
    // }
  },
  computed: {
    emptyFilter: function() {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
